export const actionType = {
  showNotify: "showNotify", // 通知
  hideNotify: "hideNotify",
  showDialog: "showDialog", // 弹框
  hideDialog: "hideDialog",
  showToast: "showToast", // 轻提示
  hideToast: "hideToast",
  showLoading: "showLoading",
  hideLoading: "hideLoading",
  pop: "pop", // 返回上一级路由
  routerPush: "routerPush", // 路由
  routerReplace: "routerReplace",//替换路由
  picturePreview: "picturePreview", // 预览图片
  refresh: "refresh",//刷新页面
  backHome: "backHome", // 返回首页
  backUser: "backUser", //返回用户中心
  clickCopy: "clickCopy", //复制文本
  gotoPay: "gotoPay", //跳转信用卡支付
  exitapp: "exitapp",//退出APP
  //极光推送
  setAlias: "setAlias",
  initJpush: "initJpush",
};
